import { proxyCall } from './base';

export interface LeadHistoryEntry {
  ts: string;       // ISO timestamp
  type: 'created' | 'status_changed' | 'comment' | 'read';
  text: string;     // human-readable description
  author?: string;  // user name who made the action
  oldStatus?: string;
  newStatus?: string;
}

export interface CrmUser {
  id: string;
  name: string;
  username: string;
  password: string;
  role: 'admin' | 'head_manager' | 'manager';
  createdAt: string;
}

export interface CrmActivityLogEntry {
  id: string;
  leadId: string;
  userName: string;
  action: string;
  createdAt: string;
}

export interface DealerLead {
  id: string;
  createdAt: string;
  name: string;
  company: string;
  phone: string;
  email: string;
  city: string;
  message: string;
  status: string;
  notes: string;
  read: number; // 0 = unread, 1 = read
  source: string;
  ip: string;
}

export const dealerLeadsDb = {
  list: (status?: string) =>
    proxyCall<DealerLead[]>('list', 'dealerLeads', {
      ...(status ? { where: { status } } : {}),
      orderBy: { createdAt: 'desc' },
    }),
  get: (id: string) =>
    proxyCall<DealerLead>('get', 'dealerLeads', { id }),
  upsert: (data: Partial<DealerLead> & { id: string }) =>
    proxyCall('upsert', 'dealerLeads', data),
  delete: (id: string) =>
    proxyCall('delete', 'dealerLeads', { id }),
  count: (status?: string) =>
    proxyCall<number>('count', 'dealerLeads', status ? { where: { status } } : undefined),
};

export const crmUsersDb = {
  list: () =>
    proxyCall<CrmUser[]>('list', 'crmUsers', { orderBy: { createdAt: 'asc' } }),
  get: (id: string) =>
    proxyCall<CrmUser>('get', 'crmUsers', { id }),
  findByUsername: (username: string) =>
    proxyCall<CrmUser[]>('list', 'crmUsers', { where: { username } }),
  upsert: (data: Partial<CrmUser> & { id: string }) =>
    proxyCall('upsert', 'crmUsers', { ...data }),
  delete: (id: string) =>
    proxyCall('delete', 'crmUsers', { id }),
};

export const crmActivityLogDb = {
  listByLead: (leadId: string) =>
    proxyCall<CrmActivityLogEntry[]>('list', 'crmActivityLog', {
      where: { leadId },
      orderBy: { createdAt: 'asc' },
    }),
  add: (entry: Omit<CrmActivityLogEntry, 'createdAt'>) =>
    proxyCall('upsert', 'crmActivityLog', {
      ...entry,
      createdAt: new Date().toISOString(),
    }),
};

export const crmActivityLogAllDb = {
  list: (limit = 500) =>
    proxyCall<CrmActivityLogEntry[]>('list', 'crmActivityLog', {
      orderBy: { createdAt: 'desc' },
      limit,
    }),
};
